import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { requestAddress } from 'requests/postal-api/getAddress'
import { onlyNumbers, postalCode } from 'utils/format'
import { ADDRESS } from 'constants/objects/address'
import { STATES } from 'constants/address-states'
import { Form as FormComponent } from 'components/Form'
import {
  TitleForm,
  InputForm,
  SelectForm,
} from 'components/Form/components'
import {
  AddressFields,
  CityFields,
} from './styles'

export default function AddressForm(props) {
  const {
    address,
    onCancel,
    onSave,
    saving,
  } = props

  const [attributes, setAttributes] = useState({})
  const [errorMessage, setErrorMessage] = useState()
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(Boolean(address.city?.ibge_code))

  useEffect(() => {
    setAttributes({ ...address })
  }, [address])

  const handleSave = () => {
    onSave(attributes)
  }

  const handleChange = (evt) => {
    const { name, value } = evt.target
    setAttributes({
      ...attributes,
      [name]: value,
    })
  }

  const emptyAddress = () => {
    setAttributes({
      ...ADDRESS,
      postal_code: attributes.postal_code,
    })
  }

  const getAddress = async () => {
    setLoading(true)
    setDisable(false)
    const response = await requestAddress(attributes.postal_code)

    setLoading(false)
    if (!response) {
      emptyAddress()
      return setErrorMessage('CEP não localizado')
    }

    setDisable(true)
    setErrorMessage(null)
    return setAttributes({
      postal_code: response.id,
      ...response.attributes,
    })
  }

  const selectedState = () => ({
    value: attributes.state?.abbr,
    label: attributes.state?.name,
  })

  const handleBlur = () => {
    if (!attributes.postal_code.length) {
      setDisable(false)
      return emptyAddress()
    }

    return getAddress()
  }

  const handlePostalCodeChange = (evt) => {
    const { value } = evt.target
    const code = onlyNumbers(value).substr(0, 8)

    setAttributes({
      ...attributes,
      postal_code: code,
    })
  }

  const handleChangeCity = (evt) => {
    const { value } = evt.target

    setAttributes({
      ...attributes,
      city: {
        ...attributes.city,
        name: value,
      },
    })
  }

  const handleChangeState = (option) => {
    const { value, label } = option

    setAttributes({
      ...attributes,
      state: {
        ...attributes.state,
        abbr: value,
        name: label,
      },
    })
  }

  return (
    <FormComponent
      onCancel={onCancel}
      onSave={handleSave}
      saving={saving}
    >
      <TitleForm>Endereço</TitleForm>
      <InputForm
        label="Descrição"
        type="text"
        name="description"
        value={attributes.description}
        onChange={handleChange}
        placeholder="Casa, Trabalho, etc"
      />

      <InputForm
        label="CEP"
        type="text"
        name="postal_code"
        value={postalCode(attributes.postal_code)}
        onChange={handlePostalCodeChange}
        onBlur={handleBlur}
        loading={loading}
        error={Boolean(errorMessage)}
        helperText={errorMessage}
      />

      <AddressFields>
        <InputForm
          fullWidth
          label="Endereço"
          type="text"
          name="address"
          value={attributes.address}
          onChange={handleChange}
          disabled={disable}
        />

        <InputForm
          fullWidth
          label="Número"
          type="text"
          name="number"
          value={attributes.number}
          onChange={handleChange}
        />
      </AddressFields>
      <InputForm
        fullWidth
        label="Bairro"
        type="text"
        name="district"
        value={attributes.district}
        onChange={handleChange}
        disabled={disable}
      />

      <CityFields>
        <InputForm
          fullWidth
          label="Cidade"
          type="text"
          name="city"
          value={attributes.city?.name || ''}
          onChange={handleChangeCity}
          disabled={disable}
        />
        <SelectForm
          options={STATES}
          fullWidth
          label="Estado"
          name="state"
          value={selectedState()}
          onChange={handleChangeState}
          disabled={disable}
        />
      </CityFields>

      <InputForm
        fullWidth
        label="Complemento"
        type="text"
        name="complement"
        value={attributes.complement}
        onChange={handleChange}
      />
    </FormComponent>
  )
}

AddressForm.propTypes = {
  address: PropTypes.objectOf(PropTypes.any),
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool,
}

AddressForm.defaultProps = {
  address: { attributes: {} },
  saving: false,
}
